export default "__VITE_ASSET__BO1bvM33__"